export default __webpack_public_path__ + "static/media/aboutpage.8f3a4001.png";